














import { Component, Prop, Emit, Watch, Vue, PropSync } from 'vue-property-decorator'

@Component
export default class ConfirmationModal extends Vue {
  @PropSync('show', { type: Boolean, default: false })
  public dialog!: boolean

  @Prop({ type: String, default: 'Confirm'})
  public readonly title!: string

  @Prop({ type: String, default: 'Would you like to continue?'})
  public readonly text!: string

  @Prop({ type: String, default: 'Ok'})
  public readonly confirmText!: string

  @Prop({ type: String, default: 'primary'})
  public readonly confirmColor!: string

  @Prop({ type: String, default: 'Cancel'})
  public readonly cancelText!: string

  @Prop({ type: String })
  public readonly cancelColor!: string

  @Emit('confirmation')
  public confirm() {
    this.dialog = false
    return true
  }

  @Emit('confirmation')
  public cancel() {
    this.dialog = false
    return false
  }
}
